import styled from "styled-components";

export const TitleText = styled.p`
  margin-bottom: 0;
  color: ${({ theme }) => theme.color.brandPrimary.light};
`;

export const SubtitleSection = styled.p`
  margin-bottom: 24px;
`;
